<template>
  <main id="profilePage" class="container mb-3">
    <div class="row">
      <CustomerProfileNavComponent id="sideNav"
                                   class="col-lg-4 col-sm-12 side-nav"
      ></CustomerProfileNavComponent>
      <div class="col-lg-8 col col-sm-12 profile-page">
        <div class="profile-main-wrapper">
          <h3 class="header-title">{{ $t('profile_page_title') }}</h3>

          <div class="col-12">
            <!-- Template for customer inputs -->
            <div class="row" v-if="! this.store.state.customer.company_name">
              <div class="col-md-12">
                <p class="header-slug">{{ $t('personal_info') }}</p>
              </div>
              <div class="col-md-6" v-for="input in customerForm.inputs">
                <InputComponent
                    class="profile-input"
                    :name-input="input.name"
                    :data-type="input.dataType"
                    :placeholder="$t(input.placeholder)"
                    v-model:data="input.value"
                    :msg="input.validation"></InputComponent>
              </div>
            </div>

            <!-- Template for company inputs -->
            <div class="row" v-else>
              <div class="col-md-12">
                <p class="header-slug">{{ $t('company_info') }}</p>
              </div>
              <div class="col-md-6" v-for="input in companyForm.inputs">
                <InputComponent class="profile-input"
                                :name-input="input.name"
                                :data-type="input.dataType"
                                :placeholder="$t(input.placeholder)"
                                v-model:data="input.value"
                                :msg="input.validation"></InputComponent>
              </div>
            </div>

            <div class="pb-3">
              <button class="button" @click="submit()" :disabled="loading" :class="{'less-padding-06': loading}">
                <span>{{ $t('save') }}</span>
                <span v-if="customerForm.loading" class="customer-loader"></span>
              </button>

              <!-- Success and error messages -->
              <div class="mt-2" v-if="customerForm.errors.length || customerForm.success">
                <template v-for="error in customerForm.errors">
                  <div class="font-small error-color">
                    {{ $t(error) }}
                  </div>
                </template>

                <template v-if="customerForm.success">
                  <div class="font-small success-color">
                    {{ $t('saved') }}
                  </div>
                </template>
              </div>
            </div>
            <hr>

            <!-- Wrapper for password inputs -->
            <div class="pt-3">
              <p class="header-slug">{{ $t('change_password') }}</p>
              <PasswordRequirementsCardComponent />
              <div class="row">
                <div class="col-md-6" v-for="input in passwordForm.inputs">
                  <InputComponent class="profile-input"
                                  :name-input="input.name"
                                  :data-type="input.dataType"
                                  :placeholder="$t(input.placeholder)"
                                  v-model:data="input.value"
                                  :msg="input.validation"></InputComponent>
                </div>
              </div>
            </div>

            <button class="button" @click="submitPasswordUpdate()" :disabled="loading" :class="{'less-padding-06': loading}">
              {{ $t('change') }}
              <span v-if="passwordForm.loading" class="customer-loader"></span>
            </button>

            <!-- Success and error messages -->
            <div class="mt-2" v-if="passwordForm.errors.length || passwordForm.success">
              <template v-for="error in passwordForm.errors">
                <div class="font-small error-color">
                  {{ $t(error) }}
                </div>
              </template>

              <template v-if="passwordForm.success">
                <div class="font-small success-color">
                  {{ $t('saved') }}
                </div>
              </template>
            </div>
          </div>
        </div>
<!--      <div class="d-inline-block col-lg-8 col col-sm-12 profile-page">-->
<!--        <Customer-profile-my-info-component-->
<!--            class="d-table-cell"-->
<!--            v-if="switchToPage === 'my_info'">-->
<!--        </Customer-profile-my-info-component>-->
<!--        <customer-purchase-history-component-->
<!--            class="d-table-cell"-->
<!--            v-if="switchToPage === 'purchase_history'"-->
<!--            @showTicket="switchComponent"-->
<!--            @ticketData="getTicketData"-->
<!--            :ticketData="ticketData"-->
<!--            :style="{height: navHeight + 'px'}">-->
<!--        </customer-purchase-history-component>-->
<!--        <CustomerProfileSettingsComponent-->
<!--            class="d-table-cell"-->
<!--            v-if="switchToPage === 'settings'"-->
<!--            :style="{height: navHeight + 'px'}">-->
<!--        </CustomerProfileSettingsComponent>-->
<!--        <TicketComponent class="d-table-cell"-->
<!--             v-if="switchToPage === 'ticket'">-->
<!--        </TicketComponent>-->
<!--      </div>-->
    </div>
    </div>
  </main>
</template>

<script lang="ts">
import './profile.scss';

import {useStore} from "vuex";
import type {IForm} from "@/interfaces/IForm.interface";
import type {IInput} from "@/interfaces/IInput.interface";
import type {ICustomerDataResponse} from "@/interfaces/ICustomerDataResponse.interface";
import FormValidationService from "../../services/formValidationService";
import apiService from "../../services/apiService";

import axios from "axios";
import {defineComponent} from "vue";
import NameOfHelper from "../../helpers/nameOfHelper";

// @ts-ignore
import InputComponent from "../../components/input/InputComponent.vue";
// @ts-ignore
import CustomerProfileNavComponent from "../../components/CustomerProfileNav/CustomerProfileNavComponent.vue";
//@ts-ignore
import PasswordRequirementsCardComponent from "../../components/passwordRequirementsCard/PasswordRequirementsCardComponent.vue";

export default defineComponent({
  name: "ProfilePage",
  components: {
    PasswordRequirementsCardComponent,
    InputComponent,
    CustomerProfileNavComponent,
  },
  setup() {
    const store = useStore();

    return {
      store
    }
  },
  data() {
    return {
      loading: false,
      passwordForm: <IForm>{
        isValid: false,
        inputs: <IInput[]>[
          <IInput>{
            key: 'current_password',
            name: 'current_password',
            dataType: 'password',
            placeholder: 'current_password',
            value: null,
            validation: {
              state: true,
              message: null,
              rules: {
                required: {},
              }
            }
          },
          <IInput>{
            key: 'password',
            name: 'new_password',
            dataType: 'password',
            placeholder: 'new_password',
            value: null,
            validation: {
              state: true,
              message: null,
              rules: {
                required: {},
                password: {},
              }
            }
          },
          <IInput>{
            key: 'repeat_password',
            name: 'repeat_password',
            dataType: 'password',
            placeholder: 'repeat_password',
            value: null,
            validation: {
              state: true,
              message: null,
              rules: {
                required: {},
                password_match: {},
              }
            }
          }
        ],
        success: false,
        errors: [],
      },
      companyForm: <IForm>{
        isValid: false,
        inputs: <IInput[]>[
          <IInput>{
            key: 'company_name',
            name: 'company_name',
            dataType: 'text',
            placeholder: 'company_name',
            // @ts-ignore
            value: this.store.state.customer.company_name ?? null,
            validation: {
              state: true,
              message: null,
              rules: {
                required: {message: 'please_enter_valid_company_name'}
              }
            }
          },
          <IInput>{
            key: 'company_number',
            name: 'company_number',
            dataType: 'text',
            placeholder: 'company_code',
            // @ts-ignore
            value: this.store.state.customer.company_number ?? null,
            validation: {
              state: true,
              message: null,
              rules: {
                required: {message: 'please_enter_valid_company_code'}
              }
            }
          },
          <IInput>{
            key: 'company_vat',
            name: 'company_vat',
            dataType: 'text',
            placeholder: 'vat_code',
            // @ts-ignore
            value: this.store.state.customer.company_vat ?? null,
            validation: {
              state: true,
              message: null,
              rules: {
              }
            }
          },
          <IInput>{
            key: 'address',
            name: 'address',
            dataType: 'text',
            placeholder: 'address',
            // @ts-ignore
            value: this.store.state.customer.address ?? null,
            validation: {
              state: true,
              message: null,
              rules: {
                required: {message: 'please_enter_valid_company_address'}
              }
            }
          },
          <IInput>{
            key: 'email',
            name: 'email',
            dataType: 'text',
            placeholder: 'e_mail',
            // @ts-ignore
            value: this.store.state.customer.email ?? null,
            validation: {
              state: true,
              message: null,
              rules: {
                required: {message: 'Please_Enter_your_email'},
                email: {message: 'Please_Enter_your_valid_email'}
              }
            }
          },
          <IInput>{
            key: 'mobno',
            name: 'mobno',
            dataType: 'tel',
            placeholder: 'phone',
            // @ts-ignore
            value: this.store.state.customer.mobno ?? null,
            validation: {
              state: true,
              message: null,
              rules: {
                required: {message: 'please_enter_valid_phone'}
              }
            }
          },
        ]
      },
      customerForm: <IForm>{
        isValid: false,
        inputs: <IInput[]>[
          <IInput>{
            key: 'first_name',
            name: 'first_name',
            dataType: 'text',
            placeholder: 'first_name',
            // @ts-ignore
            value: this.store.state.customer.first_name ?? null,
            validation: {
              state: true,
              message: null,
              rules: {
                required: {message: 'please_enter_valid_first_name'}
              }
            }
          },
          <IInput>{
            key: 'last_name',
            name: 'last_name',
            dataType: 'text',
            placeholder: 'last_name',
            // @ts-ignore
            value: this.store.state.customer.last_name ?? null,
            validation: {
              state: true,
              message: null,
              rules: {
                required: {message: 'please_enter_valid_last_name'}
              }
            }
          },
          <IInput>{
            key: 'email',
            name: 'email',
            dataType: 'text',
            placeholder: 'e_mail',
            // @ts-ignore
            value: this.store.state.customer.email ?? null,
            validation: {
              state: true,
              message: null,
              rules: {
                required: {message: 'Please_Enter_your_email'},
                email: {message: 'Please_Enter_your_valid_email'}
              }
            }
          },
          <IInput>{
            key: 'mobno',
            name: 'mobno',
            dataType: 'tel',
            placeholder: 'phone',
            // @ts-ignore
            value: this.store.state.customer.mobno ?? null,
            validation: {
              state: true,
              message: null,
              rules: {
                required: {message: 'please_enter_valid_phone'}
              }
            }
          },
        ],
        success: false,
        errors: [],
      },
      // navHeight: null,
      // isHidden: false,
      // ticketData: null,
    };
  },
  methods: {
    submit() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      this.customerForm.loading = true;

      this.customerForm.success = false;
      this.customerForm.errors = [];

      const companyName = this.store.state.customer.company_name;

      let data = {'is_company': !! companyName};
      let inputs = companyName ? this.companyForm.inputs : this.customerForm.inputs;

      if (! FormValidationService.validate(inputs)) {
        this.loading = false;
        this.customerForm.loading = false;
        return;
      }

      for (const input of inputs) {
        data[input.key] = input.value;
      }

      axios.post(apiService.customerUpdate(), data)
          .then(response => {
            let responseData = <ICustomerDataResponse>response.data

            const state = this.store.state.customer;
            const nameOf = (c) => NameOfHelper.obj(c);

            this.store.commit( 'customer/SET_STATE_PROP_VALUE', [
              {prop: nameOf(() => state.first_name), value: responseData.first_name},
              {prop: nameOf(() => state.last_name), value: responseData.last_name},
              {prop: nameOf(() => state.email), value: responseData.email},
              {prop: nameOf(() => state.mobno), value: responseData.mobno},
              {prop: nameOf(() => state.company_name), value: responseData.company_name},
              {prop: nameOf(() => state.company_number), value: responseData.company_number },
              {prop: nameOf(() => state.company_vat), value: responseData.company_vat},
              {prop: nameOf(() => state.address), value: responseData.address},
            ]);

            this.customerForm.success = true;

            setTimeout(() => {
              this.customerForm.success = false;
            }, 3000);
          })
          .catch(error => {
            this.customerForm.errors = [];

            const response = error.response;

            if (response.status === 422) {
              const data =  response.data.errors;

              for (const prop in data) {
                if (!data.hasOwnProperty(prop)) {
                  continue;
                }
                for (const error of data[prop]) {
                  this.customerForm.errors.push(prop + '.' + error);
                }
              }

              return;
            }

            this.customerForm.errors.push('key_loading_error');
            console.error(error);
          })
          .finally(() => {
            this.loading = false;
            this.customerForm.loading = false;
          })
    },
    submitPasswordUpdate() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      this.passwordForm.loading = true;

      this.passwordForm.success = false;
      this.passwordForm.errors = [];

      const inputs = this.passwordForm.inputs;

      if (! FormValidationService.validate(inputs)) {
        this.loading = false;
        this.passwordForm.loading = false;
        return;
      }

      let data = {};

      for (const prop in inputs) {
        if (! inputs.hasOwnProperty(prop)) {
          continue;
        }
        const input = inputs[prop];
        data[input.key] = input.value;

        this.passwordForm.inputs[prop].value = '';
      }

      axios.post(apiService.customerUpdatePassword(), data)
          .then(response => {
            this.passwordForm.success = true;

            setTimeout(() => {
              this.passwordForm.success = false;
            }, 3000);
          })
          .catch(error => {
            this.passwordForm.errors = [];

            const response = error.response;

            if (response.status === 422) {
              const data =  response.data.errors;

              for (const prop in data) {
                if (!data.hasOwnProperty(prop)) {
                  continue;
                }
                for (const error of data[prop]) {
                  this.passwordForm.errors.push(prop + '.' + error);
                }
              }

              return;
            }

            this.passwordForm.errors.push('key_loading_error');
            console.error(error);
          })
          .finally(() => {
            this.loading = false;
            this.passwordForm.loading = false;
          })
    },
    // getTicketData: function (data) {
    //   this.ticketData = data;
    // }
  }
});
</script>